import "../../assets/css/suppliers/supplierProfile.css"

import back from "../../assets/images/arrowForward.svg"
import starRating from "../../assets/images/starRating.svg"
import save from "../../assets/images/save.svg"
import cvpBadge from "../../assets/images/CVPBagdeProfile.png"
import profileExample from "../../assets/images/profileExample.png"

import React, { useEffect, useState } from "react"
import { useSupplierProfileData, useSupplierProfileMutations } from "./suppliersProfile/hooks"
import { Dropdown, Modal, Tab, Tabs, Tooltip, OverlayTrigger } from "react-bootstrap"
import { useLocation, useNavigate, useParams } from "react-router-dom"

import InformationCompliance from "../tabs/informationCompliance.jsx";
import QualitySurvey from "../tabs/qualitySurvey.jsx";
import DocumentComplianceTable from "../tabs/documentCompliance/documentComplianceTable.jsx"
import WarehousesTab from "../tabs/warehousesTab/warehousesTab.jsx"
import ProductAssignment from "../tabs/productAssignment/productAssignment.jsx"
import AddClientUserModal from "../clientsAdminView/addClientUserModal.jsx"

import ProductsAndServices from "../tabs/productAndService.jsx"
import Contracts from "../tabs/contracts.jsx"
import { checkInformationCompliance } from "../../utilities/utils.js"
import StaffList from "../tabs/staff/staffList.jsx"
import addIcon from "../../assets/images/add.svg"
import UsersTab from "./UsersTab.jsx"
import { useAuth } from "../../context/auth-user.jsx"



// MODAL TO SHOW THE CLIENT LIST
function SupplierClientsModalSupplierProfile(props) {
	const navigate = useNavigate()
	const { user } = useAuth()
	const userLogged = user?.selectedProfile

	// OJO: el primer argumento es el clientID (el _id de la ENTITY), no el _id
	// del subdocumento de supplier.clients[]. El backend busca por clientID
	// (supplierController.js: updateClientStatus) y con el _id devolvia 404
	// siempre. Ver spec-06.
	//
	// Tampoco se pisa aqui el estado con la respuesta: updateClientStatus
	// devuelve el proveedor CRUDO de supplier.save(), sin el clientName por
	// cliente, sin los porcentajes de compliance y sin el filtrado de clients
	// por rol que agrega getSupplierByID. La mutacion ya invalida la query, que
	// vuelve a traerlo enriquecido.
	const handleClientStatusChange = async (clientID, newStatus) => {
		try {
			await props.handleStatusChange(clientID, newStatus)
		} catch (error) {
			// La mutacion ya muestra el toast de error; esto solo evita que
			// quede una promesa rechazada sin manejar.
			console.log("Error al cambiar el status del cliente: " + error)
		}
	}

	return (
		<Modal
			className={`supplierClientsModalSupplierProfile ${userLogged?.darkLightMode ? "darkMode" : ""}`}
			size="lg"
			centered
			show={props.show}
			onHide={props.onHide}
		>
			<Modal.Body>
				<h5 className="commentTitle">Clients</h5>
				<table className="tableClients">
					<thead>
						<tr>
							<th><span>Name</span></th>
							<th><span>Status</span></th>
							<th><span>Actions</span></th>
						</tr>
					</thead>
					<tbody>
						{props.supplierClients && props.supplierClients.map((supplierClient, index) => {
							switch (props.userLogged?.rol) {
								case "Master":
								case "Super admin":
									return (
										<tr key={index}>
											<td>
												<div className="infoContainer">
													<span>{props.clients && props.clients.find(clients => clients.entities.find(entity => entity._id === supplierClient.clientID)).entities.find(entity => entity._id === supplierClient.clientID).entityName}</span>
												</div>
											</td>
											<td>
												<div className="infoContainer">
													<span className={`${supplierClient.status === "Ready for review" ? "success" : ""} ${supplierClient.status === "Pre-authorized" || supplierClient.status === "Review requested" ? "pending" : ""} ${supplierClient.status === "New request" ? "new" : ""}`}>
														{supplierClient.status}
													</span>
												</div>
											</td>
											<td>
												<div className="infoContainer">
													<span className="actions">
														{supplierClient.status === "Active" || supplierClient.status === "Rejected" || supplierClient.status === "Authorized" ?
															<Dropdown>
																<Dropdown.Toggle
																	className={`${supplierClient.status ? "" : "default"} 
																	${supplierClient.status === "Active" ? "successAlone" : ""} 
																	${supplierClient.status === "Authorized" ? "newAlone" : ""} 
																	${supplierClient.status === "Rejected" ? "failedAlone" : ""}`}
																>
																	{supplierClient.status}
																</Dropdown.Toggle>

																<Dropdown.Menu>
																	<Dropdown.Item className="success"
																		onClick={(e) => {
																			const newValue = e.target.innerText

																			handleClientStatusChange(supplierClient.clientID, newValue)
																		}}>Active</Dropdown.Item>
																	<Dropdown.Item className="new"
																		onClick={(e) => {
																			const newValue = e.target.innerText

																			handleClientStatusChange(supplierClient.clientID, newValue)
																		}}>Authorized</Dropdown.Item>
																	<Dropdown.Item className="failedAlone"
																		onClick={(e) => {
																			const newValue = e.target.innerText

																			handleClientStatusChange(supplierClient.clientID, newValue)
																		}}>Rejected</Dropdown.Item>
																</Dropdown.Menu>
															</Dropdown> :
															<React.Fragment>
																{"No actions required"}
																< button className="btnBgBlueTextGradient" onClick={(e) => navigate("/home/requests/reviewForAuth/" + props.supplier._id)}>
																	Review</button>
															</React.Fragment>
														}
													</span>
												</div>
											</td>
										</tr>
									)

								case "Admin client":
								case "Admin Compliance manager":
									const clientEntitiesIDs = props.clients && props.clients.find(client => client._id.toString() === props.userLogged.dataID.toString()).entities.map(entity => entity._id.toString())
									return (
										clientEntitiesIDs && clientEntitiesIDs.includes(supplierClient.clientID) && <tr key={index}>
											<td>
												<div className="infoContainer">
													<span>{props.clients && props.clients.find(clients => clients.entities.find(entity => entity._id === supplierClient.clientID)).entities.find(entity => entity._id === supplierClient.clientID).entityName}</span>
												</div>
											</td>
											<td>
												<div className="infoContainer">
													<span className={`${supplierClient.status === "Ready for review" ? "success" : ""} ${supplierClient.status === "Pre-authorized" || supplierClient.status === "Review requested" ? "pending" : ""} ${supplierClient.status === "New request" ? "new" : ""}`}>
														{supplierClient.status}
													</span>
												</div>
											</td>
											<td>
												<div className="infoContainer">
													<span className="actions">
														{supplierClient.status === "Active" || supplierClient.status === "Rejected" || supplierClient.status === "Authorized" ?
															<Dropdown>
																<Dropdown.Toggle
																	className={`${supplierClient.status ? "" : "default"} 
																${supplierClient.status === "Active" ? "successAlone" : ""} 
																${supplierClient.status === "Authorized" ? "newAlone" : ""} 
																${supplierClient.status === "Rejected" ? "failedAlone" : ""}`}
																>
																	{supplierClient.status}
																</Dropdown.Toggle>

																<Dropdown.Menu>
																	<Dropdown.Item className="success"
																		onClick={(e) => {
																			const newValue = e.target.innerText

																			handleClientStatusChange(supplierClient.clientID, newValue)
																		}}>Active</Dropdown.Item>
																	<Dropdown.Item className="new"
																		onClick={(e) => {
																			const newValue = e.target.innerText

																			handleClientStatusChange(supplierClient.clientID, newValue)
																		}}>Authorized</Dropdown.Item>
																	<Dropdown.Item className="failedAlone"
																		onClick={(e) => {
																			const newValue = e.target.innerText

																			handleClientStatusChange(supplierClient.clientID, newValue)
																		}}>Rejected</Dropdown.Item>
																</Dropdown.Menu>
															</Dropdown> :
															"No actions required"
														}
													</span>
												</div>
											</td>
										</tr>
									)

								default:
									break;
							}
						})}
					</tbody>
				</table>

				<div className="d-lg-none mobileCientList">
					{props.supplierClients && props.supplierClients.map((supplierClient, index) => {
						switch (props.userLogged?.rol) {
							case "Master":
							case "Super admin":
								return (
									<div key={index} className="clientRow">
										<span className="clientHeaderTitle">{props.clients.find(clients => clients.entities.find(entity => entity._id === supplierClient.clientID)).entities.find(entity => entity._id === supplierClient.clientID).entityName}</span>
										<span className={`clientValue ${(() => {
											switch (supplierClient.status) {
												case "Active":
												case "Ready for review":
													return "success"

												case "Pre-authorized":
												case "Review requested":
													return "pending"

												case "New request":
													return "new"

												case "Rejected":
													return "failed"

												default:
													break;
											}
										})()}`}>
											{supplierClient.status}
										</span>
										<span className="clientTitle">Status</span>
										<span className="clientValue actions">
											{supplierClient.status === "Active" || supplierClient.status === "Rejected" || supplierClient.status === "Authorized" ?
												<Dropdown>
													<Dropdown.Toggle
														className={`${supplierClient.status ? "" : "default"} 
																	${supplierClient.status === "Active" ? "successAlone" : ""} 
																	${supplierClient.status === "Authorized" ? "newAlone" : ""} 
																	${supplierClient.status === "Rejected" ? "failedAlone" : ""}`}
													>
														{supplierClient.status}
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<Dropdown.Item className="success"
															onClick={(e) => {
																const newValue = e.target.innerText

																handleClientStatusChange(supplierClient.clientID, newValue)
															}}>Active</Dropdown.Item>
														<Dropdown.Item className="new"
															onClick={(e) => {
																const newValue = e.target.innerText

																handleClientStatusChange(supplierClient.clientID, newValue)
															}}>Authorized</Dropdown.Item>
														<Dropdown.Item className="failedAlone"
															onClick={(e) => {
																const newValue = e.target.innerText

																handleClientStatusChange(supplierClient.clientID, newValue)
															}}>Rejected</Dropdown.Item>
													</Dropdown.Menu>
												</Dropdown> :
												<React.Fragment>
													{"No actions required"}
													< button className="btnBgBlueTextGradient" onClick={(e) => navigate("/home/requests/reviewForAuth/" + props.supplier._id)}>
														Review</button>
												</React.Fragment>
											}
										</span>
										<span className="clientTitle">Action</span>
									</div>
								)

							case "Admin client":
							case "Admin Compliance manager":
								const clientEntitiesIDs = props.clients && props.clients.find(client => client._id.toString() === props.userLogged.dataID.toString()).entities.map(entity => entity._id.toString())
								return (
									clientEntitiesIDs && clientEntitiesIDs.includes(supplierClient.clientID) && <div key={index} className="clientRow">
										<span className="clientHeaderTitle">{props.clients.find(clients => clients.entities.find(entity => entity._id === supplierClient.clientID)).entities.find(entity => entity._id === supplierClient.clientID).entityName}</span>
										<span className={`clientValue ${(() => {
											switch (supplierClient.status) {
												case "Active":
												case "Ready for review":
													return "success"

												case "Pre-authorized":
												case "Review requested":
													return "pending"

												case "New request":
													return "new"

												case "Rejected":
													return "failed"

												default:
													break;
											}
										})()}`}>
											{supplierClient.status}
										</span>
										<span className="clientTitle">Status</span>
										<span className="clientValue actions">
											{supplierClient.status === "Active" || supplierClient.status === "Rejected" || supplierClient.status === "Authorized" ?
												<Dropdown>
													<Dropdown.Toggle
														className={`${supplierClient.status ? "" : "default"} 
																${supplierClient.status === "Active" ? "successAlone" : ""} 
																${supplierClient.status === "Authorized" ? "newAlone" : ""} 
																${supplierClient.status === "Rejected" ? "failedAlone" : ""}`}
													>
														{supplierClient.status}
													</Dropdown.Toggle>

													<Dropdown.Menu>
														<Dropdown.Item className="success"
															onClick={(e) => {
																const newValue = e.target.innerText

																handleClientStatusChange(supplierClient.clientID, newValue)
															}}>Active</Dropdown.Item>
														<Dropdown.Item className="new"
															onClick={(e) => {
																const newValue = e.target.innerText

																handleClientStatusChange(supplierClient.clientID, newValue)
															}}>Authorized</Dropdown.Item>
														<Dropdown.Item className="failedAlone"
															onClick={(e) => {
																const newValue = e.target.innerText

																handleClientStatusChange(supplierClient.clientID, newValue)
															}}>Rejected</Dropdown.Item>
													</Dropdown.Menu>
												</Dropdown> :
												"No actions required"
											}
										</span>
										<span className="clientTitle">Action</span>
									</div>
								)

							default:
								break;
						}
					})}
				</div>

				<div className="actionButton">
					<button className="btnBgBlueTextGradient" onClick={props.onHide}>Close</button>
				</div>
			</Modal.Body >
		</Modal >
	)
}

// MODAL TO SHOW ALL THE SUPPLIER INDUSTRIES
function SupplierIndustriesModalSupplierProfile(props) {
	const { show, onHide, supplierIndustries } = props
	return (
		<Modal
			className="supplierIndustriesModalReviewForAuth"
			size="lg"
			centered
			show={show}
			onHide={onHide}
		>
			<Modal.Body>
				<h4 className="commentTitle">Industries</h4>

				<div className="industriesContainer">
					{supplierIndustries.map((industry, index) => (
						<span key={index} className="industry">{industry}</span>
					))}
				</div>

				<div className="actionButton">
					<button className="btnBgBlueTextGradient" onClick={onHide}>Close</button>
				</div>
			</Modal.Body>
		</Modal>
	)
}

export default function SupplierProfile({ darkLightMode }) {
	// VARIABLES TO MANAGE THE USER LOGGED
	const { user } = useAuth()
	const userLogged = user?.selectedProfile
	const fromAlerts = useLocation()

	// VARIABLE TO MANAGE SUPPLIER INFO
	const [supplier, setSupplier] = useState(null);

	const [showAddUserModal, setShowAddUserModal] = useState(false)

	const [key, setKey] = useState(() => {
		const searchParams = new URLSearchParams(fromAlerts.search)
		const paramsExist = searchParams.get("fromAlerts")


		return paramsExist === "doc" ? "Document compliance" : 'Information Completed'
	});

	const [users, setUsers] = useState([])

	useEffect(() => {
		const cleanedUrl = fromAlerts.pathname.split("?")[0];
		window.history.replaceState(null, "", cleanedUrl);
	}, [])

	// VARIABLE TO SHOW THE CLIENTS MODAL
	const [showClientsModal, setShowClientsModal] = useState(false)

	// VARIABLE TO SHOW THE INDUSTRIES MODAL
	const [showIndustriesModal, setShowIndustriesModal] = useState(false)

	// VARIABLES TO CONTROL THE PERCERT COMPLETED FOR THE TABS
	const [informationCompliancePercent, setInformationCompliancePercent] = useState(0)
	const [documentCompliancePercent, setDocumentCompliancePercent] = useState(0)
	const [historicDocumentCompliancePercent, setHistoricDocumentCompliancePercent] = useState(0)

	const navigate = useNavigate()

	const { id } = useParams();

	const { supplierData, serverDate, clients, users: usersData, username } = useSupplierProfileData({ id, userLogged })
	const { handleSaveChanges, handleChangeSupplierActive, handleSendNotification, handleStatusChange } = useSupplierProfileMutations({ id })

	useEffect(() => { if (supplierData) setSupplier(supplierData) }, [supplierData])
	useEffect(() => { if (usersData) setUsers(usersData) }, [usersData])
	useEffect(() => {
		if (!supplier || !serverDate) return
		setInformationCompliancePercent(checkInformationCompliance(supplier.informationCompliance))
		setDocumentCompliancePercent(supplier.documentCompliancePercent ?? 0)
		setHistoricDocumentCompliancePercent(supplier.historicDocumentCompliancePercent ?? 0)
		supplier.informationCompliance.generalInformation.hasRepse && evaluateStaffCompliancy()
	}, [supplier, serverDate])

	useEffect(() => {
		supplier && supplier.informationCompliance.generalInformation.hasRepse && serverDate && evaluateStaffCompliancy()
	}, [key])

	// FUNCTION TO EVALUATE IF THE STAFF IS COMPLIANT AND CHANGE THE STAFF TAB
	const evaluateStaffCompliancy = () => {
		const element = document.getElementById("controlled-tab-example-tab-staff")

		if (supplier.staffCompliance) {
			element.classList.remove("nonCompliant")
		} else {
			element.classList.add("nonCompliant")
		}
	}

	return (
		<section className={`supplierProfile ${darkLightMode ? "darkMode" : null}`}>
			<div className="header">
				<div className="generalInformation">
					<div className="headInformation">
						<img className="goBack" src={back} alt="Prodensa Supplier" onClick={() => navigate(-1)} />
						<img className="profilePhoto" src={
							supplier && supplier.informationCompliance.generalInformation.profilePhoto.document && !supplier.informationCompliance.generalInformation.profilePhoto.document.name
								? process.env.REACT_APP_URI_UPLOADS + supplier.informationCompliance.generalInformation.rfc + "/" + supplier.informationCompliance.generalInformation.profilePhoto.document
								: profileExample
						} alt="Prodensa Supplier" />
						<h3>
							{supplier && supplier.informationCompliance.generalInformation.companyName}
							<span>All time document compliant: {historicDocumentCompliancePercent}%</span>
						</h3>
						<h4 className="ratingValue">
							{supplier && supplier.rating ? supplier.rating.$numberDecimal : "Unrated"}
							{supplier && supplier.rating && supplier.rating.$numberDecimal ? <img className="ratingImg" src={starRating} alt="Prodensa Supplier" /> : undefined}
						</h4>
					</div>
					<div className="industriesInformation">
						<div className="industriesContainer">
							{supplier && supplier.informationCompliance.facilitiesCapabilities.categories.map((category, index) => (
								index < 4 && <span key={index}>{category}</span>
							))}
						</div>
						{supplier && supplier.informationCompliance.facilitiesCapabilities.categories.length > 3 && <button className="btnBgBlueTextGradient" onClick={() => setShowIndustriesModal(true)}>
							See all ({supplier && supplier.informationCompliance.facilitiesCapabilities.categories.length})
						</button>}
					</div>
					<p className="description">{supplier && supplier.informationCompliance.facilitiesCapabilities.description}</p>
					{(userLogged?.rol === "Client" || userLogged?.rol === "Compliance manager") && <div className="inputContainer">
						<Dropdown>
							<Dropdown.Toggle
								className={`${supplier && supplier.clients.find(client => client.clientID === userLogged.dataID).status ? "" : "default"} 
										${supplier && supplier.clients.find(client => client.clientID === userLogged.dataID).status === "Active" ? "successAlone" : ""} 
										${supplier && supplier.clients.find(client => client.clientID === userLogged.dataID).status === "Authorized" ? "newAlone" : ""} 
										${supplier && supplier.clients.find(client => client.clientID === userLogged.dataID).status === "Rejected" ? "failedAlone" : ""}`}
							>
								{supplier ? supplier.clients.find(client => client.clientID === userLogged.dataID).status : "State"}
							</Dropdown.Toggle>

							<Dropdown.Menu>
								<Dropdown.Item className="success"
									onClick={(e) => {
										const supplierCopy = JSON.parse(JSON.stringify(supplier))
										const clientToUpdate = supplierCopy.clients.find(client => client.clientID === userLogged.dataID)
										const prevStatusToSave = {
											prevStatus: clientToUpdate.status,
											dateStatusChanged: serverDate.date,
											lastAdded: true
										}

										const newStatusHistory = clientToUpdate.statusHistory.filter(sta => !sta.lastAdded)
										newStatusHistory.push(prevStatusToSave)

										clientToUpdate.statusHistory = newStatusHistory

										clientToUpdate.status = e.target.innerText
										setSupplier(supplierCopy)
									}}>Active</Dropdown.Item>
								<Dropdown.Item className="new"
									onClick={(e) => {
										const supplierCopy = JSON.parse(JSON.stringify(supplier))
										const clientToUpdate = supplierCopy.clients.find(client => client.clientID === userLogged.dataID)
										const prevStatusToSave = {
											prevStatus: clientToUpdate.status,
											dateStatusChanged: serverDate.date,
											lastAdded: true
										}

										const newStatusHistory = clientToUpdate.statusHistory.filter(sta => !sta.lastAdded)
										newStatusHistory.push(prevStatusToSave)

										clientToUpdate.statusHistory = newStatusHistory

										clientToUpdate.status = e.target.innerText
										setSupplier(supplierCopy)
									}}>Authorized</Dropdown.Item>
								<Dropdown.Item className="failedAlone"
									onClick={(e) => {
										const supplierCopy = JSON.parse(JSON.stringify(supplier))
										const clientToUpdate = supplierCopy.clients.find(client => client.clientID === userLogged.dataID)
										const prevStatusToSave = {
											prevStatus: clientToUpdate.status,
											dateStatusChanged: serverDate.date,
											lastAdded: true
										}

										const newStatusHistory = clientToUpdate.statusHistory.filter(sta => !sta.lastAdded)
										newStatusHistory.push(prevStatusToSave)

										clientToUpdate.statusHistory = newStatusHistory

										clientToUpdate.status = e.target.innerText
										setSupplier(supplierCopy)
									}}>Rejected</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					</div>}

					<div className="actionsContainer">
						{(userLogged?.rol === "Master" || userLogged?.rol === "Super admin" || userLogged?.rol === "Admin client" || userLogged?.rol === "Admin Compliance manager") && <button className="btnBgBlueTextGradient" onClick={() => setShowClientsModal(true)}>
							View actions for clients
						</button>}

						<OverlayTrigger placement="top"
							overlay={<Tooltip id="send-email-tooltip">
								Send email to supplier
							</Tooltip>}>
							<button className="btnBgBlueTextGradient send-email"
								onClick={() => handleSendNotification(supplier.informationCompliance.generalInformation.contactInformation.email)}
							>
								Send comments
							</button>
						</OverlayTrigger>
					</div>
				</div>

				<div className="contactInformation">
					{supplier && supplier.informationCompliance.generalInformation.cvp.certified && <img className="cvpBadge" src={cvpBadge} alt="Prodensa Supplier" />}
					<div className="info">
						<span className="infoTitle">Address</span>
						<span className="infoText">
							{supplier && supplier.informationCompliance.generalInformation.address.streetAndNumber}<br />
							C.P. {supplier && supplier.informationCompliance.generalInformation.address.zipCode}<br />
							{supplier && supplier.informationCompliance.generalInformation.address.city + " " + supplier.informationCompliance.generalInformation.address.state}

						</span>
					</div>
					<div className="info">
						<span className="infoTitle">Contact information</span>
						<span className="infoText">
							{supplier && supplier.informationCompliance.generalInformation.contactInformation?.name}<br />
							{supplier && supplier.informationCompliance.generalInformation.contactInformation?.email}<br />
							{supplier && supplier.informationCompliance.generalInformation.contactInformation?.phone}
						</span>
					</div>
					<div className="info">
						<span className="infoTitle">Website</span>
						<span className="infoText">{supplier && supplier.informationCompliance.generalInformation.website}</span>
					</div>

					{(userLogged?.rol === "Master" || userLogged?.rol === "Super admin") && <div className={`statusButton ${supplier && supplier.activeSupplier ? "active" : ""}`} onClick={() => handleChangeSupplierActive(supplier)}>
						<div className="statusBall"></div>
					</div>}
				</div>
				{(userLogged?.rol === "Client" || userLogged?.rol === "Compliance manager") && <div className="inputContainer d-lg-none">
					<Dropdown>
						<Dropdown.Toggle
							className={`${supplier && supplier.clients.find(client => client.clientID === userLogged.dataID).status ? "" : "default"} 
										${supplier && supplier.clients.find(client => client.clientID === userLogged.dataID).status === "Active" ? "successAlone" : ""} 
										${supplier && supplier.clients.find(client => client.clientID === userLogged.dataID).status === "Authorized" ? "newAlone" : ""} 
										${supplier && supplier.clients.find(client => client.clientID === userLogged.dataID).status === "Rejected" ? "failedAlone" : ""}`}
						>
							{supplier ? supplier.clients.find(client => client.clientID === userLogged.dataID).status : "State"}
						</Dropdown.Toggle>

						<Dropdown.Menu>
							<Dropdown.Item className="success"
								onClick={(e) => {
									const supplierCopy = JSON.parse(JSON.stringify(supplier))
									const clientToUpdate = supplierCopy.clients.find(client => client.clientID === userLogged.dataID)
									const prevStatusToSave = {
										prevStatus: clientToUpdate.status,
										dateStatusChanged: serverDate.date,
										lastAdded: true
									}

									const newStatusHistory = clientToUpdate.statusHistory.filter(sta => !sta.lastAdded)
									newStatusHistory.push(prevStatusToSave)

									clientToUpdate.statusHistory = newStatusHistory

									clientToUpdate.status = e.target.innerText
									setSupplier(supplierCopy)
								}}>Active</Dropdown.Item>
							<Dropdown.Item className="new"
								onClick={(e) => {
									const supplierCopy = JSON.parse(JSON.stringify(supplier))
									const clientToUpdate = supplierCopy.clients.find(client => client.clientID === userLogged.dataID)
									const prevStatusToSave = {
										prevStatus: clientToUpdate.status,
										dateStatusChanged: serverDate.date,
										lastAdded: true
									}

									const newStatusHistory = clientToUpdate.statusHistory.filter(sta => !sta.lastAdded)
									newStatusHistory.push(prevStatusToSave)

									clientToUpdate.statusHistory = newStatusHistory

									clientToUpdate.status = e.target.innerText
									setSupplier(supplierCopy)
								}}>Authorized</Dropdown.Item>
							<Dropdown.Item className="failedAlone"
								onClick={(e) => {
									const supplierCopy = JSON.parse(JSON.stringify(supplier))
									const clientToUpdate = supplierCopy.clients.find(client => client.clientID === userLogged.dataID)
									const prevStatusToSave = {
										prevStatus: clientToUpdate.status,
										dateStatusChanged: serverDate.date,
										lastAdded: true
									}

									const newStatusHistory = clientToUpdate.statusHistory.filter(sta => !sta.lastAdded)
									newStatusHistory.push(prevStatusToSave)

									clientToUpdate.statusHistory = newStatusHistory

									clientToUpdate.status = e.target.innerText
									setSupplier(supplierCopy)
								}}>Rejected</Dropdown.Item>
						</Dropdown.Menu>
					</Dropdown>
				</div>}

				{(userLogged?.rol === "Master" || userLogged?.rol === "Super admin" || userLogged?.rol === "Admin client" || userLogged?.rol === "Admin Compliance manager") && <button className="btnBgBlueTextGradient d-lg-none" onClick={() => setShowClientsModal(true)}>
					View actions for clients
				</button>}

				<OverlayTrigger placement="top"
					overlay={<Tooltip id="send-email-tooltip">
						Send email to supplier
					</Tooltip>}>
					<button className="btnBgBlueTextGradient send-email d-lg-none"
						onClick={() => handleSendNotification(supplier.informationCompliance.generalInformation.contactInformation.email)}
					>
						Send comments
					</button>
				</OverlayTrigger>
			</div>

			<div className="tabs-container">
				<Tabs
					id="controlled-tab-example"
					activeKey={key}
					onSelect={(k) => setKey(k)}
				>
					<Tab eventKey="Information Completed" title={`1 Information Completed (${informationCompliancePercent}%)`}>
						{supplier && serverDate && <InformationCompliance
							supplier={supplier}
							informationCompliance={supplier.informationCompliance}
							setSupplier={setSupplier}
							username={username}
							serverDate={serverDate}
							handleSaveChanges={handleSaveChanges}
						/>}
					</Tab>
					<Tab eventKey="Document compliance" title={`2 Document compliance (${documentCompliancePercent}%)`}>
						{supplier && <DocumentComplianceTable
							supplier={supplier}
							setSupplier={setSupplier}
							serverDate={serverDate}
							userLogged={userLogged}
							darkLightMode={darkLightMode}
						/>}
					</Tab>
					{supplier?.informationCompliance?.generalInformation?.hasRepse && (
						<Tab eventKey="staff" title="3 Staff">
							{supplier && <StaffList
								supplier={supplier}
							/>}
						</Tab>
					)}
					<Tab eventKey="Quality Survey" title="4 Quality Survey">
						{supplier && <QualitySurvey
							qualitySurvey={supplier.qualitySurvey}
							setSupplier={setSupplier}
							rfc={supplier.informationCompliance.generalInformation.rfc}
						/>}
					</Tab>
					{userLogged?.rol !== "Admin Compliance manager" && userLogged?.rol !== "Compliance manager" &&
						<Tab eventKey="Products/Services" title="5 Products/Services">
							{supplier && serverDate && <ProductsAndServices
								darkLightMode={darkLightMode}
								supplier={supplier}
								productsAndServices={supplier.productsAndServices}
								setSupplier={setSupplier}
								serverDate={serverDate}
								userLogged={userLogged}
								rfc={supplier.informationCompliance.generalInformation.rfc}
								handleSaveChanges={handleSaveChanges}
							/>}
						</Tab>}
					{userLogged?.rol !== "Admin Compliance manager" && userLogged?.rol !== "Compliance manager" &&
						<Tab eventKey="Warehouses" title="6 Warehouses">
							{supplier && serverDate && <WarehousesTab
								darkLightMode={darkLightMode}
								supplier={supplier}
								supplierProducts={supplier.productsAndServices.products}
								supplierWarehouses={supplier.warehouses}
								setSupplier={setSupplier}
								handleSaveChanges={handleSaveChanges}
							/>}
						</Tab>}
					{userLogged?.rol !== "Admin Compliance manager" && userLogged?.rol !== "Compliance manager" &&
						<Tab eventKey="Products Assignation" title="7 Product Assignment">
							{supplier && serverDate && <ProductAssignment
								supplier={supplier}
								supplierProducts={supplier.productsAndServices.products}
								supplierWarehouses={supplier.warehouses}
								setSupplier={setSupplier}
								handleSaveChanges={handleSaveChanges}
							/>}
						</Tab>}
					<Tab eventKey="contracts" title="8 Contracts">
						{supplier && <Contracts
							supplier={supplier}
							clients={supplier.clients}
							setSupplier={setSupplier}
							serverDate={serverDate}
							userLogged={userLogged}
							rfc={supplier.informationCompliance.generalInformation.rfc}
							handleSaveChanges={handleSaveChanges}
						/>}
					</Tab>
					{supplier && (userLogged?.rol === "Master" || userLogged?.rol === "Super admin") &&
						<Tab eventKey="users" title="9 Users">
							<UsersTab
								users={users}
								setUsers={setUsers}
								supplierId={id}
							/>
						</Tab>}
				</Tabs>

				{(userLogged?.rol === "Master" || userLogged?.rol === "Super admin") && <button className="btnBgBlueTextGradient addUserButton"
					onClick={() => setShowAddUserModal(true)}
				>
					<img src={addIcon} alt="Prodensa Supplier" />
					Add user
				</button>}
			</div>

			{key !== "Document compliance" && <div className="actionButtons">
				<button className="btnBgBlueTextGradient" onClick={() => navigate(-1)}>Discard changes</button>
				<button className="btnBgBlueTextGradient" onClick={() => handleSaveChanges(supplier)}>Save changes</button>
			</div>}

			<button className="saveChanges" onClick={() => handleSaveChanges(supplier)}>
				<img src={save} alt="Prodensa Supplier" />
			</button>

			{supplier && clients && <SupplierClientsModalSupplierProfile
				supplier={supplier}
				supplierClients={supplier.clients}
				clients={clients}
				show={showClientsModal}
				onHide={() => setShowClientsModal(false)}
				userLogged={userLogged}
				handleStatusChange={handleStatusChange}
			/>}

			{supplier && <SupplierIndustriesModalSupplierProfile
				supplierIndustries={supplier.informationCompliance.facilitiesCapabilities.categories}
				show={showIndustriesModal}
				onHide={() => setShowIndustriesModal(false)}
			/>}

			{supplier && <AddClientUserModal
				darkLightMode={darkLightMode}
				show={showAddUserModal}
				onHide={() => setShowAddUserModal(false)}
				client={supplier}
				setUsers={setUsers}
			/>}
		</section>
	)
}